export default __webpack_public_path__ + "static/media/tg_logo.a7835d87.svg";